import React, {Component} from 'react'
import './styles.css'
import {Formik, Field, Form} from 'formik'
import {api} from '../../services/api'
import {apiEmployee} from '../../services/apiamrg'
import Header from '../../components/header'
import {connect} from 'react-redux'
import {Redirect} from 'react-router-dom'
import {PRECISA_LOGAR} from '../../config'

const md5 = require(`md5`)

const estadoInicial = {
    username: '',
    name: '',
    email: '',
    phone: '',
    password: null,
    confirmPassword: null,
    id: null,
    redirect: false,
    finalizaOperacao: false,
    trocarSenha: false,
    employee: []
}

class AddEmployee extends Component {
    
    state = {
        ...estadoInicial
    }

    componentDidMount = async () => {
        window.scrollTo(0, 0)
        var id = await this.props.match.params.id
        await this.setState({id, token: this.props.token})
        if(id !== 0){
            await this.setState({employee: this.props.location.state.employee})
            await this.loadData(this.props.location.state.employee)
        }       
    }

    loadData = async (produto) => {
        await this.setState({username: produto.username, name: produto.name, email: produto.email, phone: produto.phone})
    }

    carregaEmployees = async () => {
        await api.get(`employees`, {
            headers: {
                "Authorization": `bearer ${this.props.token}`
            }
        }).then(
            response => {this.setState({employees: response.data})}, 
            response => this.erroApi(response)
        ) 
    }

    salvarEmployee = async () => {
        let password = this.state.password ? md5(this.state.password) : null
        //$cols = 'username, name, email, phone, password';
        if(this.state.id === 0){            
            let values = `'${this.state.username}', '${this.state.name}', ` + 
            `'${this.state.email}', '${this.state.phone}', '${password}'`
            await apiEmployee.post(`insertEmployee.php`, {
                token: this.props.token,
                values: values
            }).then(
                async res => {
                    await alert(res.data)
                    await this.setState({finalizaOperacao: true})
                },
                async res => await alert(`erro: ${res.data}`)
            )
        }else{
           await apiEmployee.post(`updateEmployee.php`, {
                token: this.props.token,
                id_employee: this.state.id,
                username: this.state.username,
                name: this.state.name,                
                email: this.state.email,
                phone: this.state.phone,
                password: password
           }).then(
               async res => {
                   await alert(res.data)
                   await this.setState({finalizaOperacao: true})
               },
               async res => await alert(`Erro: ${res.data}`)
           )
        }
    }
    
    erroApi = async (response) => {
        alert(PRECISA_LOGAR)
        await this.setState({redirect: true})
    }

    limpaControles = async () => {
        await this.setState({name: ''})
    }

    render(){
        const validations = []
        validations.push(this.state.name && this.state.name.trim().length >= 4)
        validations.push(this.state.username && this.state.username.trim().length >= 4)
        validations.push(this.state.phone && this.state.phone.trim().length >= 8)
        validations.push(this.state.email && this.state.email.includes('@'))
        {this.state.trocarSenha && this.state.id > 0 &&
            validations.push(this.state.password && this.state.password.trim().length >= 4)
            validations.push(this.state.password === this.state.confirmPassword)
        }
        {this.state.id === 0 &&
            validations.push(this.state.password && this.state.password.trim().length >= 4)
            validations.push(this.state.password === this.state.confirmPassword)
        }
        

        //o formulário só será válido se todas as validações forem verdadeiras, com este reduce implementado
        const validForm = validations.reduce((t, a) => t && a)
        
        return (
            <div>
                {this.state.redirect &&
                    <Redirect to={'/admin'} />
                }
                {this.state.finalizaOperacao &&
                <Redirect to={'/admin/employees'} />
                }
                <section className="page-add">
                    <Header voltarEmployee/>
                    
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-8 text-right">
                                <div className="page-breadcrumb">
                                    <h2 style={{marginBottom: '3%', marginTop: '3%'}}>{this.state.id === 0 ? 'Inserir novo employee' : 'Alterar employee'}</h2>
                                </div>
                            </div>
                            <div className="col-2"></div>
                        </div>

                </section>

                <div className="contact-section">
                    
                        <div className="row">
                            <div className="col-2"></div>
                            <div className="col-8">
                                <Formik 
                                initialValues={{
                                    name: '',
                                }}
                                onSubmit={async values => {
                                    await new Promise(r => setTimeout(r, 1000))
                                    this.salvarEmployee()
                                }}
                                >
                                    <Form className="contact-form">

                                    <div className="row">
                                        
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-left">
                                            <Field name="username" id="username" placeholder="User Name" type="text" value={this.state.username} onChange={async e => { await this.setState({username: e.currentTarget.value})}}/>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-left">
                                            <Field name="name" id="name" placeholder="Name" type="text" value={this.state.name} onChange={async e => { await this.setState({name: e.currentTarget.value})}}/>
                                        </div>

                                    </div>

                                    <div className="row">
                                        
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-left">
                                            <Field name="email" id="email" placeholder="e-mail" type="mail" value={this.state.email} onChange={async e => { await this.setState({email: e.currentTarget.value})}}/>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-left">
                                            <Field name="phone" id="phone" placeholder="Telephone" type="phone" value={this.state.phone} onChange={async e => { await this.setState({phone: e.currentTarget.value})}}/>
                                        </div>
                                        
                                    </div>

                                    {this.state.id > 0 &&
                                        <div className="row">
                                        <div className="col-2 text-left">
                                                <label htmlFor="trocarsenha" className="form-check-label">Alterar senha</label>
                                            </div>
                                            <div className="col-1 text-left">
                                                <Field onClick={async (e) => { await this.setState({trocarSenha: !this.state.trocarSenha, password: null, confirmPassword: null}) }} checked={this.state.trocarSenha} name="trocarsenha" id="trocarsenha" type="checkbox" />
                                            </div>
                                        </div>
                                    }

                                    {this.state.trocarSenha && this.state.id > 0 &&

                                        <div className="row">
                                            
                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-left">
                                                <Field name="password" id="password" placeholder="Password" type="password" value={this.state.password} onChange={async e => { await this.setState({password: e.currentTarget.value})}}/>
                                            </div>
                                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-left">
                                                <Field name="confirmpassword" id="confirmpassword" placeholder="Confirm Password" type="password" value={this.state.confirmPassword} onChange={async e => { await this.setState({confirmPassword: e.currentTarget.value})}}/>
                                            </div>
                                            
                                        </div>
                                    }

                                    {this.state.id === 0 &&

                                    <div className="row">
                                        
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-left">
                                            <Field name="password" id="password" placeholder="Password" type="password" value={this.state.password} onChange={async e => { await this.setState({password: e.currentTarget.value})}}/>
                                        </div>
                                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 text-left">
                                            <Field name="confirmpassword" id="confirmpassword" placeholder="Confirm Password" type="password" value={this.state.confirmPassword} onChange={async e => { await this.setState({confirmPassword: e.currentTarget.value})}}/>
                                        </div>
                                        
                                    </div>
                                    }
                                    
                                    <div className="row">
                                        <div className="col-lg-12 text-right">
                                        <button disabled={!validForm} type="submit" style={validForm ? {} : {backgroundColor: '#eee', opacity: 0.3} } >{this.state.id === 0 ? 'Salvar' : 'Alterar'}</button>
                                        </div>
                                    </div>

                                    </Form>
                                </Formik>
                            </div>
                            <div className="col-2"></div>
                        </div>
                </div>
            </div>
        )
        
    }
}

const mapStateToProps = ({user}) => {
    return{
        token: user.token
    }
}

export default connect(mapStateToProps, null)(AddEmployee)
